export default __webpack_public_path__ + "static/mask-group-phone-6f3ea7bba4c79991c35056ff2d821bcb.webp";